module.exports = __webpack_public_path__ + "static/media/HP-Icon3-@2x.54e73476.png";